module.exports = __webpack_public_path__ + "img/IMG_20180408_154653.2610499f.jpg";